import Vue from 'vue'
import App from './vue_pages/App.vue'

import {store} from './store'
import {router} from './routes'
import {mapGetters} from 'vuex'

import './js/device.min'

import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueStickyKit from 'vue-stickykit'
import YmapPlugin from 'vue-yandex-maps'
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueNativeSock from 'vue-native-websocket'



import vSelect from 'vue-select'
import Search from './vue_components/Search.vue'

import Vue2TouchEvents from 'vue2-touch-events'

// import vueShapeImg from 'vueshapeimg'
// Vue.use(vueShapeImg)


Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueAwesomeSwiper);
Vue.use(VueStickyKit);
Vue.use(YmapPlugin);
Vue.use(VueTextareaAutosize);
Vue.use(Vue2TouchEvents)

Vue.component('v-select', vSelect);
Vue.component('cmp-search', Search);

import {
    SOCKET_ONOPEN,
    SOCKET_ONCLOSE,
    SOCKET_ONERROR,
    SOCKET_ONMESSAGE,
    SOCKET_RECONNECT,
    SOCKET_RECONNECT_ERROR
} from './store/mutation-types'

const mutations = {
    SOCKET_ONOPEN,
    SOCKET_ONCLOSE,
    SOCKET_ONERROR,
    SOCKET_ONMESSAGE,
    SOCKET_RECONNECT,
    SOCKET_RECONNECT_ERROR
};

if(process.env.NODE_ENV === 'production'){
    Vue.use(VueNativeSock, location.protocol.replace('http', 'ws') + '//' + window.location.host + '/ws', {
        store: store,
        mutations: mutations,
        format: 'json'
    });
}

Date.prototype.daysInMonth = function() {
    return 33 - new Date(this.getFullYear(), this.getMonth(), 33).getDate();
};

new Vue({
    store,
    router,
    el: '#app',
    render: h => h(App),
    watch: {
        socketToken(){
            if(this.socketToken !== null)
                this.$socket.send(JSON.stringify(this.socketToken));
        }
    },
    computed: {
        ...mapGetters('profile', ['hasAuth', 'socketToken']),
        ...mapGetters(['hasAuth'])
    },
    methods: {
        getCoords(elem) {
            let box = elem.getBoundingClientRect();
            let body = document.body;
            let docEl = document.documentElement;

            let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            let clientTop = docEl.clientTop || body.clientTop || 0;
            let clientLeft = docEl.clientLeft || body.clientLeft || 0;

            let top = box.top + scrollTop - clientTop;
            let left = box.left + scrollLeft - clientLeft;

            return {
                top: top,
                left: left
            };
        },
        resize(){
            device.mobile() || window.innerWidth < 770 ?
                store.dispatch('updateMobileState', true) :
                store.dispatch('updateMobileState', false);

            window.innerWidth < 1124 ?
                store.dispatch('updateMobileCalendar', true) :
                store.dispatch('updateMobileCalendar', false);
        },
        ScrollTo(id){
            let elem = document.getElementById(id);
            if(elem){
                let elem_coord = this.getCoords(elem);

                let  scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if(elem_coord.top > scrollTop){
                    scrollTop + 30 > elem_coord.top ? scrollTop = elem_coord.top : scrollTop += 30;
                    window.scrollTo(0, scrollTop);
                    setTimeout(() => {
                        let scrollHeight = Math.max(
                            document.body.scrollHeight, document.documentElement.scrollHeight,
                            document.body.offsetHeight, document.documentElement.offsetHeight,
                            document.body.clientHeight, document.documentElement.clientHeight
                        );
                        if(scrollTop < elem_coord.top && (scrollTop + window.innerHeight) < scrollHeight)
                            this.ScrollTo(id)
                    }, 1)
                } else{
                    scrollTop - 30 < elem_coord.top ? scrollTop = elem_coord.top : scrollTop -= 30;
                    window.scrollTo(0, scrollTop);
                    setTimeout(() => {
                        if(scrollTop > elem_coord.top)
                            this.ScrollTo(id)
                    }, 1)
                }
            }
        },
        CloseMenuServ(e){
            let menu = document.querySelector('.t-headerMenu');
            if(menu !== null){
                let target = e.target;
                let its_menu = target === menu || menu.contains(target);
                if (!its_menu && (store.getters.menuState || store.getters.menuState_profile)) {
                    store.dispatch('menuClose')
                }
            }
        },
        CloseFilter(e){
            let filter = document.querySelector('.t-filter');
            if(filter !== null){
                let target = e.target;
                let its_filter = target === filter || filter.contains(target);
                if (!its_filter && store.getters.filterState) {
                    store.dispatch('filterClose')
                }
            }
        },
        CloseSort(e){
            let sort = document.querySelector('.t-sort');
            if(sort !== null){
                let target = e.target;
                let its_sort = target === sort || sort.contains(target);
                if (!its_sort && store.getters.sortState) {
                    store.dispatch('sortClose')
                }
            }
        }
    },
    beforeCreate(){
        // store.dispatch('locale/LoadLocale', _json);

        device.mobile() || window.innerWidth < 770 ?
            store.dispatch('updateMobileState', true) :
            store.dispatch('updateMobileState', false);

        window.innerWidth < 1124 ?
            store.dispatch('updateMobileCalendar', true) :
            store.dispatch('updateMobileCalendar', false);

        window.onresize = () => {
            this.resize();
        };

        window.onscroll = () => {
            if(!this.mobile){
                let nav_pos = this.$root.getCoords(document.querySelector('footer')).top;

                let scrollTop = 0;

                try{
                    scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
                    let stop = scrollTop + window.innerHeight;

                    nav_pos >= stop ? store.dispatch('callbackSetNoAbsolute') : store.dispatch('callbackSetAbsolute');
                }
                catch (error){
                    store.dispatch('callbackSetNoAbsolute')
                }

                store.dispatch('faq/scroll', scrollTop);
                store.dispatch('terms_service/scroll', scrollTop);
            }
        };
    },
    mounted(){
        document.addEventListener('click', (e) => {
            this.CloseMenuServ(e);
            this.CloseFilter(e);
            this.CloseSort(e);
        });
    }
});






//Vue.cookie.delete('locale');

// let req = getXmlHttp();
// req.onreadystatechange = function() {
//     if (req.readyState === 4) {
//         if(req.status === 200) {
//             let _json = JSON.parse(req.responseText);

//             let base_local = '';

//             let locale_arr = [];
//             for(let i = 0; i < _json.items.length; i ++){
//                 locale_arr.push(_json.items[i].value);
//             }
//             let path = [];
//             for(let i = 0; i < router.options.routes.length; i++){
//                 path.push(router.options.routes[i].path);
//             }

//             let locale = Vue.cookie.get('locale');
//             let pathname = window.location.pathname.split('/');

//             if(locale === null){
//                 if(pathname[1] === ''){
//                     locale = navigator.systemLanguage || window.navigator.language || navigator.userLanguage || navigator.browserLanguage;

//                     if(locale_arr.indexOf(locale) >= 0){
//                         Vue.cookie.set('locale', locale, { expires: '1Y' });

//                         base_local = locale;
//                     } else{
//                         Vue.cookie.set('locale', '', { expires: '1Y' });
//                     }
//                 } else{
//                     if(locale_arr.indexOf(pathname[1]) >= 0){
//                         Vue.cookie.set('locale', pathname[1], { expires: '1Y' });

//                         base_local = pathname[1];
//                     } else{
//                         if(path.indexOf('/' + pathname[1]) >= 0){
//                             Vue.cookie.set('locale', '', { expires: '1Y' });
//                         } else{
//                             console.log('error')
//                         }
//                     }
//                 }
//             } else{
//                 if(locale === pathname[1]){
//                     base_local = locale;
//                 } else{
//                     if(locale_arr.indexOf(pathname[1]) >= 0){
//                         Vue.cookie.set('locale', pathname[1], { expires: '1Y' });

//                         base_local = pathname[1];
//                     } else{
//                         if(path.indexOf('/' + pathname[1]) >= 0){
//                             Vue.cookie.set('locale', '', { expires: '1Y' });
//                         } else{
//                             console.log('error')
//                         }
//                     }
//                 }
//             }

//             Vue.http.options.credentials = true;
//             if(process.env.NODE_ENV !== 'production')
//                 Vue.http.options.root = '/json_requests';
//             else
//                 Vue.http.options.root = window.location.protocol + '//api.' + window.location.host + '/' + base_local;

//             if(base_local === '')
//                 router.history.base = base_local;
//             else
//                 router.history.base = '/' + base_local;

//             new Vue({
//                 store,
//                 router,
//                 el: '#app',
//                 render: h => h(App),
//                 watch: {
//                     socketToken(){
//                         if(this.socketToken !== null)
//                             this.$socket.send(JSON.stringify(this.socketToken));
//                     }
//                 },
//                 computed: {
//                     ...mapGetters('profile', ['hasAuth', 'socketToken']),
//                     ...mapGetters(['hasAuth'])
//                 },
//                 methods: {
//                     getCoords(elem) {
//                         let box = elem.getBoundingClientRect();
//                         let body = document.body;
//                         let docEl = document.documentElement;

//                         let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
//                         let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

//                         let clientTop = docEl.clientTop || body.clientTop || 0;
//                         let clientLeft = docEl.clientLeft || body.clientLeft || 0;

//                         let top = box.top + scrollTop - clientTop;
//                         let left = box.left + scrollLeft - clientLeft;

//                         return {
//                             top: top,
//                             left: left
//                         };
//                     },
//                     resize(){
//                         device.mobile() || window.innerWidth < 770 ?
//                             store.dispatch('updateMobileState', true) :
//                             store.dispatch('updateMobileState', false);

//                         window.innerWidth < 1124 ?
//                             store.dispatch('updateMobileCalendar', true) :
//                             store.dispatch('updateMobileCalendar', false);
//                     },
//                     ScrollTo(id){
//                         let elem = document.getElementById(id);
//                         if(elem){
//                             let elem_coord = this.getCoords(elem);

//                             let  scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//                             if(elem_coord.top > scrollTop){
//                                 scrollTop + 30 > elem_coord.top ? scrollTop = elem_coord.top : scrollTop += 30;
//                                 window.scrollTo(0, scrollTop);
//                                 setTimeout(() => {
//                                     let scrollHeight = Math.max(
//                                         document.body.scrollHeight, document.documentElement.scrollHeight,
//                                         document.body.offsetHeight, document.documentElement.offsetHeight,
//                                         document.body.clientHeight, document.documentElement.clientHeight
//                                     );
//                                     if(scrollTop < elem_coord.top && (scrollTop + window.innerHeight) < scrollHeight)
//                                         this.ScrollTo(id)
//                                 }, 1)
//                             } else{
//                                 scrollTop - 30 < elem_coord.top ? scrollTop = elem_coord.top : scrollTop -= 30;
//                                 window.scrollTo(0, scrollTop);
//                                 setTimeout(() => {
//                                     if(scrollTop > elem_coord.top)
//                                         this.ScrollTo(id)
//                                 }, 1)
//                             }
//                         }
//                     },
//                     CloseMenuServ(e){
//                         let menu = document.querySelector('.t-headerMenu');
//                         if(menu !== null){
//                             let target = e.target;
//                             let its_menu = target === menu || menu.contains(target);
//                             if (!its_menu && (store.getters.menuState || store.getters.menuState_profile)) {
//                                 store.dispatch('menuClose')
//                             }
//                         }
//                     },
//                     CloseFilter(e){
//                         let filter = document.querySelector('.t-filter');
//                         if(filter !== null){
//                             let target = e.target;
//                             let its_filter = target === filter || filter.contains(target);
//                             if (!its_filter && store.getters.filterState) {
//                                 store.dispatch('filterClose')
//                             }
//                         }
//                     },
//                     CloseSort(e){
//                         let sort = document.querySelector('.t-sort');
//                         if(sort !== null){
//                             let target = e.target;
//                             let its_sort = target === sort || sort.contains(target);
//                             if (!its_sort && store.getters.sortState) {
//                                 store.dispatch('sortClose')
//                             }
//                         }
//                     }
//                 },
//                 beforeCreate(){
//                     store.dispatch('locale/LoadLocale', _json);

//                     device.mobile() || window.innerWidth < 770 ?
//                         store.dispatch('updateMobileState', true) :
//                         store.dispatch('updateMobileState', false);

//                     window.innerWidth < 1124 ?
//                         store.dispatch('updateMobileCalendar', true) :
//                         store.dispatch('updateMobileCalendar', false);

//                     window.onresize = () => {
//                         this.resize();
//                     };

//                     window.onscroll = () => {
//                         if(!this.mobile){
//                             let nav_pos = this.$root.getCoords(document.querySelector('footer')).top;

//                             let scrollTop = 0;

//                             try{
//                                 scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
//                                 let stop = scrollTop + window.innerHeight;

//                                 nav_pos >= stop ? store.dispatch('callbackSetNoAbsolute') : store.dispatch('callbackSetAbsolute');
//                             }
//                             catch (error){
//                                 store.dispatch('callbackSetNoAbsolute')
//                             }

//                             store.dispatch('faq/scroll', scrollTop);
//                         }
//                     };
//                 },
//                 mounted(){
//                     document.addEventListener('click', (e) => {
//                         this.CloseMenuServ(e);
//                         this.CloseFilter(e);
//                         this.CloseSort(e);
//                     });
//                 }
//             });
//         }
//     }
// };

// let url_locale = process.env.NODE_ENV !== 'production' ? '/json_requests/locale.json' : window.location.protocol + '//api.' + window.location.host + '/locale';
// let tz = new Date(). getTimezoneOffset() /60;
// url_locale+='?timezone='+tz
// req.open('GET', url_locale, true);
// req.setRequestHeader( "X-Requested-With", "XMLHttpRequest" );
// req.send();

// Date.prototype.daysInMonth = function() {
//     return 33 - new Date(this.getFullYear(), this.getMonth(), 33).getDate();
// };

// function getXmlHttp(){
//     let xmlhttp;
//     try {
//         xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
//     } catch (e) {
//         try {
//             xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
//         } catch (E) {
//             xmlhttp = false;
//         }
//     }
//     if (!xmlhttp && typeof XMLHttpRequest !== 'undefined')
//         xmlhttp = new XMLHttpRequest();
//     return xmlhttp;
// }


// WEBPACK FOOTER //
// ./src/main.js